import env from '../services/environment'
import {
  INTERNET_CONNECTED,
  INTERNET_DISCONNECTED,
  API_RATELIMIT_LOCKED,
  API_RATELIMIT_UNLOCKED,
  MQTT_CONNECTED,
  MQTT_DISCONNECTED,
  MQTT_SITE_SUBSCRIBE,
  MQTT_SITE_UNSUBSCRIBE,
  ADD_LOG,
  OPEN_MENU,
  CLOSE_MENU,
  SELECT_SITE,
  SELECT_DATE,
  SELECT_CAMERA,
  SELECT_EVENT,
  SELECT_VIDEO,
  SELECT_THUMBNAILVIDEO,
  SELECT_MEMBER,
  SELECT_CONTACT
} from './mutation-types'

// initial state
const state = {
  dataParams: {
    historyRetentionDay: 30,
    maxEventSnapshots: 200,
    maxEvents: 1000
  },
  selectionParams: {
    selectedSiteId: null,
    selectedDateId: null,
    selectedCameraId: null,
    selectedEventId: null,
    selectedVideoId: null,
    selectedThumbnailVideoId: null,
    selectedMemberId: null,
    selectedContactId: null
  },
  pageParams: {
    isMenuActive: false
  },
  mqttStatus: {
    isMqttConnected: false,
    currentSiteId: null
  },
  isOnline: true,
  isApiRateLimitLocked: false,
  logs: [],
  lastLog: {}
}

// actions
const actions = {
  initializeData: function ({commit, dispatch, state}) {
    return new Promise((resolve, reject) => {
      dispatch('getMyProfile').then(() => {
        dispatch('getMySites').then(() => {
          let siteIds = Object.keys(state.sites.sites)
          // if there are available sites for user
          if (siteIds.length > 0) {
            let siteIdToBeSelected = null
            let currentEmail = state.myProfile.myProfile.email
            if (env.getLastEmail() === currentEmail) {
              if (env.getLastSiteId()) {
                if (state.sites.sites[env.getLastSiteId()]) {
                  siteIdToBeSelected = env.getLastSiteId()
                }
              }
            } else env.setLastEmail(currentEmail)
            if (!siteIdToBeSelected) siteIdToBeSelected = siteIds[0]
            dispatch('selectSite', siteIdToBeSelected)
            resolve(siteIdToBeSelected)
          } else {
            reject('There is no site available')
          }
        })
      })
    })
  },
  selectSite: function ({commit, dispatch}, siteId) {
    env.setLastSiteId(siteId)
    commit(SELECT_SITE, siteId)
    dispatch('getSiteCameras', siteId)
    dispatch('getSiteMembers', siteId)
    dispatch('getSiteContacts', siteId)
  },
  selectCamera: function ({commit, dispatch}, cameraId) {
    commit(SELECT_CAMERA, cameraId)
  },
  checkOnlineStatusByApiResponse: function ({commit, state, dispatch}, res) {
    if (res.status === 0) {
      if (state.isOnline) commit(INTERNET_DISCONNECTED)
    } else if (res.status === 429) {
      if (!state.isApiRateLimitLocked) commit(API_RATELIMIT_LOCKED)
    } else if (res.status !== 401 && res.status !== 404) {
      if (!state.isOnline) {
        commit(INTERNET_CONNECTED)
        dispatch('initializeData')
      }
      if (state.isApiRateLimitLocked) commit(API_RATELIMIT_UNLOCKED)
    }
  }
}

// getters
const getters = {
  isOnline: function (state) {
    return state.isOnline
  },
  isApiRateLimitLocked: function (state) {
    return state.isApiRateLimitLocked
  },
  lastLog: function (state) {
    return state.lastLog
  },
  logs: function (state) {
    return state.logs
  },
  currentSiteId: function (state) {
    return state.selectionParams.selectedSiteId
  },
  currentSite: function (state, getters) {
    return state.sites.sites[getters.currentSiteId]
  },
  currentCameraId: function (state) {
    return state.selectionParams.selectedCameraId
  },
  currentCamera: function (state, getters) {
    return state.cameras.cameras[getters.currentCameraId]
  },
  currentCameraLiveSnapshot: function (state, getters) {
    return state.cameras.liveSnapshot[getters.currentCameraId]
  },
  currentCameraStatusGetLiveSnapshot: function (state, getters) {
    return state.cameras.status.getLiveSnapshot[getters.currentCameraId]
  },
  historyRetentionDay: function (state) {
    return state.dataParams.historyRetentionDay
  },
  isMenuActive: function (state) {
    return state.pageParams.isMenuActive
  },
  isMqttConnected: function (state) {
    return state.mqttStatus.isMqttConnected
  },
  mqttCurrentSiteId: function (state) {
    return state.mqttStatus.currentSiteId
  }
}

// mutations
const mutations = {
  [SELECT_SITE]: function (state, siteId) {
    state.selectionParams.selectedSiteId = siteId
  },
  [SELECT_DATE]: function (state, dateId) {
    state.selectionParams.selectedDateId = dateId
  },
  [SELECT_CAMERA]: function (state, cameraId) {
    state.selectionParams.selectedCameraId = cameraId
  },
  [SELECT_EVENT]: function (state, eventId) {
    state.selectionParams.selectedEventId = eventId
  },
  [SELECT_VIDEO]: function (state, videoId) {
    state.selectionParams.selectedVideoId = videoId
  },
  [SELECT_THUMBNAILVIDEO]: function (state, thumbnailVideoId) {
    state.selectionParams.selectedThumbnailVideoId = thumbnailVideoId
  },
  [SELECT_MEMBER]: function (state, memberId) {
    state.selectionParams.selectedMemberId = memberId
  },
  [SELECT_CONTACT]: function (state, contactId) {
    state.selectionParams.selectedContactId = contactId
  },
  [OPEN_MENU]: function (state) {
    state.pageParams.isMenuActive = true
  },
  [CLOSE_MENU]: function (state) {
    state.pageParams.isMenuActive = false
  },
  [ADD_LOG]: function (state, log) {
    state.lastLog = {
      status: log.status, // success, info, warning, error
      message: log.message,
      timestamp: +(new Date()).getTime()
    }
    if (state.logs.length > 9) state.logs.shift()
    state.logs.push(state.lastLog)
  },
  [MQTT_CONNECTED]: function (state) {
    state.mqttStatus.isMqttConnected = true
  },
  [MQTT_DISCONNECTED]: function (state) {
    state.mqttStatus.isMqttConnected = false
  },
  [MQTT_SITE_SUBSCRIBE]: function (state, siteId) {
    state.mqttStatus.currentSiteId = siteId
  },
  [MQTT_SITE_UNSUBSCRIBE]: function (state, siteId) {
    // siteId is not used,, because here currently only listening one site at a time
    state.mqttStatus.currentSiteId = null
  },
  [INTERNET_CONNECTED]: function (state) {
    state.isOnline = true
  },
  [INTERNET_DISCONNECTED]: function (state) {
    state.isOnline = false
  },
  [API_RATELIMIT_LOCKED]: function (state) {
    state.isApiRateLimitLocked = true
  },
  [API_RATELIMIT_UNLOCKED]: function (state) {
    state.isApiRateLimitLocked = false
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/rootModule.js